import { IconProps } from "Icons/types";

export const OutlookIcon = ({ width = 24, height = 24 }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 21.5573C14 22.2933 14.5973 22.8906 15.3333 22.8906H26.6667C27.4027 22.8906 28 22.2933 28 21.5573V11.5573C28 10.8213 27.4027 10.224 26.6667 10.224H15.3333C14.5973 10.224 14 10.8213 14 11.5573V21.5573Z"
      fill="#03A9F4"
    />
    <path
      d="M28 12.2073V11.5573C28 11.272 27.9087 11.0086 27.7553 10.792L20.246 15.4133L15.218 12.3093L14.75 13.5573L20.3893 16.8906L28 12.2073Z"
      fill="#B3E5FC"
    />
    <path d="M18 28.5306L4 25.864V7.19729L18 4.53062V28.5306Z" fill="#0277BD" />
    <path
      d="M14.144 13.098C13.412 12.248 12.4467 11.8226 11.2587 11.8226C9.99733 11.8226 8.98666 12.2686 8.22266 13.158C7.45999 14.0493 7.07666 15.2166 7.07666 16.6553C7.07666 18.0186 7.45266 19.1313 8.20333 19.9793C8.95399 20.828 9.93133 21.2526 11.122 21.2526C12.3487 21.2526 13.3427 20.818 14.1047 19.936C14.8667 19.0606 15.246 17.9073 15.246 16.47C15.246 15.078 14.8787 13.954 14.144 13.098ZM12.6993 18.714C12.3207 19.2266 11.8067 19.482 11.1573 19.482C10.5313 19.482 10.0247 19.2193 9.63399 18.6906C9.24666 18.1673 9.05399 17.45 9.05399 16.55C9.05399 15.6593 9.24666 14.9406 9.63399 14.4C10.0247 13.86 10.546 13.5926 11.204 13.5926C11.8453 13.5926 12.3493 13.8546 12.7153 14.378C13.0853 14.908 13.2707 15.6413 13.2707 16.5846C13.2713 17.4946 13.0787 18.2026 12.6993 18.714Z"
      fill="white"
    />
  </svg>
);
